import { Course } from '../interfaces/Course';
import { User } from '../interfaces/User';

export const calculateCourseProgress = (course: Course, user: User) => {
	if (course?.tasks.length && user.completedTasks?.length) {
		const ids = course.tasks.map((task) => task.id);
		const tasksSet = new Set(ids);
		let completedTasksInCourse = 0;
		user.completedTasks.forEach((task) => {
			if (tasksSet.has(task.id)) {
				completedTasksInCourse += 1;
			}
		});
		if (completedTasksInCourse === 0) return 0;
		return Math.floor((completedTasksInCourse / course.tasks.length) * 100);
	}
	return 0;
};

export const findFirstIncompletedTask = (
	course: Course,
	user: User | null | undefined,
) => {
	if (!user || !course) return '';

	if (course?.tasks.length && user.completedTasks?.length) {
		const ids = user.completedTasks.map((task) => task.id);
		const completedTasksSet = new Set(ids);
		let firstTaskSlug: string = '';
		for (let i = 0; i < course.tasks.length; i += 1) {
			if (!completedTasksSet.has(course.tasks[i].id)) {
				firstTaskSlug = course.tasks[i].slug;
				break;
			}
		}
		const lastTaskIndex = +(course?.tasks.length || 1) - 1;
		return firstTaskSlug || course.tasks[lastTaskIndex].slug;
	}

	return course?.tasks[0]?.slug || '';
};

export const COURSE_STATUSES = {
	IN_PROGRESS: 'inprogress',
	NEW: 'new',
	COMPLETED: 'completed',
	ALL: 'all',
};

export const COURSE_FILTERS = {
	WAY: 'way',
	STATUS: 'status',
};
